<template>
  <v-container fluid class="pa-0 d-flex flex-column" style="height: inherit;">

    <!-- Primary loading indicator  -->
    <v-progress-linear v-if="loading" indeterminate :color="'primary'" absolute height="2">
    </v-progress-linear>

    <!-- Skeleton loading specifically for showing before any resources have been loaded -->
    <template v-if="loading & !resources">
      <v-row no-gutters align="center" class="d-flex flex-grow-0"
        style="background-color: white; height: 48px; border-bottom: 1px solid #e4e4e4;">
        <v-col class="px-3">
          <v-skeleton-loader type="heading">
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row no-gutters align="stretch" class="d-flex flex-grow-1">
        <v-col cols="6" class="pb-10" style="background-color: white;">
          <v-skeleton-loader type="heading" class="pa-3">
          </v-skeleton-loader>
          <v-skeleton-loader v-for="i in 7" :key="i" type="list-item" :style="'opacity:' + (8 - i) / 7 + ';'">
          </v-skeleton-loader>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="6" class="pb-10" style="background-color: #f7f7f7;">
          <v-skeleton-loader type="heading" class="py-3 px-4">
          </v-skeleton-loader>
          <v-skeleton-loader v-for="i in 4" :key="i" type="list-item-avatar-two-line" class="mx-4 my-2"
            :style="'opacity:' + (5 - i) / 4 + ';'">
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </template>

    <!-- Normal content -->
    <FolderList v-if="resources" :key="refreshKey" :resources="resources" :loading="loading"
      :defaultEmailTemplate="defaultEmailTemplate" :refreshFunc="getResourceFolder" :wide="!isPhoneBool"
      @Upload="upload" @Delete="handleDelete" @TogglePublishToCustomer="handleTogglePublishToCustomer">
    </FolderList>

    <div v-if="hasActiveChild" class="pane"
      style="position: absolute; background-color: white; z-index: 99; width: 100%;">
      <router-view>
        Overlay Route Content
      </router-view>
    </div>

  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FolderList from "@/views/pim/documents/FolderList.vue";
import Vue from 'vue';

export default {
  name: "ResourceView",
  props: {
    entityClass:
    {
      /**  Options (case-insensitive): 
          * Machine 
          * MachineModel
          * MachineType
          * Supplier
          * //Customer
          * Article
          * Job  
          * Contract
      */
      type: String,
      default: 'Machine',
      required: true,
    },
    entityId:
    {
      type: [String, Number],
      required: true,
    },
    defaultEmailTemplate: Object,
  },
  components: {
    FolderList,
  },

  data() {
    return {
      resources: null,
      loading: true,
      refreshKey: 1,
    };
  },

  mounted() {
    this.getResourceFolder();
  },

  methods: {
    async getResourceFolder() {
      if (this.entityClass && this.entityId) {
        this.loading = true;
        await clientAPI.methods.getResourcesByEntity(this.entityClass, this.entityId)
          .then((response) => {
            this.resources = response;
            this.loading = false;
            this.refreshKey++;
          });
      }
    },

    async upload(folder, doctype, files, externalContent) {
      Vue.set(folder, 'loading' + doctype, true);
      var ec = folder.InheritedFromType;
      var eid = folder.InheritedFromId;
      await clientAPI.methods.uploadResourceToEntity(ec, eid, doctype, files, externalContent)
        .then((response) => {
          //console.log('response', response);
          folder.Files = response.Files;
          folder.Folders = response.Folders;
          Vue.set(folder, 'loading' + doctype, false);
          //this.getResourceFolder();
        });
    },

    async handleDelete(folder, doctypeId, fileId) {
      Vue.set(folder, 'loading' + doctypeId, true);
      var ec = folder.InheritedFromType;
      var eid = folder.InheritedFromId;
      await clientAPI.methods.deleteResourcesFromEntity(ec, eid, doctypeId, fileId)
        .then((response) => {
          //console.log('response', response);
          folder.Files = response.Files;
          folder.Folders = response.Folders;
          Vue.set(folder, 'loading' + doctypeId, false);
          //this.getResourceFolder();
        });
    },

    async handleTogglePublishToCustomer(folder, doc) {
      Vue.set(doc, 'loadingTogglePublishToCustomer', true);
      var ec = folder.InheritedFromType;
      await clientAPI.methods.togglePublishToCustomer(ec, doc.TypeId, doc.Id)
        .then((response) => {
          doc.PublishToCustomer = response;
          Vue.set(doc, 'loadingTogglePublishToCustomer', false);
        });
    },
  },

  computed: {
    hasActiveChild() {
      return !!this.$route.meta?.resourceOverlay;
    },

    refreshReourcesTrigger() {
      return this.$store.state.triggerevents.refreshDocumentsTrigger;
    },
  },

  watch: {
    entityId: function () {
      this.getResourceFolder();
    },

    entityClass: function () {
      this.getResourceFolder();
    },

    refreshReourcesTrigger: function () {
      this.getResourceFolder();
    },
  },
};
</script>


<style scoped></style>